import { useState } from "react";
import { Nav, NavContent, NavLink, NavLogo } from "./NavbarStyle";
import WhiteLogo from "../../assets/images/p_b_white_updated.png";

const Navbar = () => {
  const [background, setBackground] = useState(false);
  const changeBackground = () => {
    if (window.scrollY > 100) {
      setBackground(true);
    } else {
      setBackground(false);
    }
  };
  window.addEventListener("scroll", changeBackground);
  return (
    <>
      <Nav className={background ? "nav-active" : ""}>
        <NavContent>
          <NavLink href="#about">ABOUT</NavLink>
          <NavLink href="#work">WORK</NavLink>
          <NavLink href="#home">
            <NavLogo src={WhiteLogo} />
          </NavLink>
          <NavLink>REVIEWS</NavLink>
          <NavLink href="#contact">CONTACT</NavLink>
        </NavContent>
      </Nav>
    </>
  );
};

export default Navbar;
